import { isNil } from 'lodash'

export const offset = (value?: number | string, offset = 0) => {
  if (isNil(value)) {
    return value
  }
  return Number.parseFloat(`${value}`) + offset
}
